import { render, staticRenderFns } from "./counterpartiesModalInfo.vue?vue&type=template&id=60a2d058"
import script from "./counterpartiesModalInfo.vue?vue&type=script&lang=js"
export * from "./counterpartiesModalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports